import { useDragLayer, XYCoord } from 'react-dnd';

import { makeStyles, Theme } from '@material-ui/core';

import { DragItem, DragItemPreview, DragItemType } from './PreparationItem';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: 100,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
    }
}));

function calculateItemStyle(currentOffset: XYCoord | null) {
    if (!currentOffset) {
        return { display: 'none' };
    }
    const { x, y } = currentOffset;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebKitTransform: transform,
    };
}

const PreparationItemDragLayer = () => {
    const classes = useStyles();
    const { item, itemType, isDragging, currentOffset } = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
        currentOffset: monitor.getSourceClientOffset(),
    }));

    if (!isDragging || itemType !== DragItemType) {
        return null;
    }

    return (
        <div className={classes.root}>
            <div style={calculateItemStyle(currentOffset)}>
                <DragItemPreview player={(item as DragItem).player} />
            </div>
        </div>
    );
};

export default PreparationItemDragLayer;
